import { SortableCollection } from "./../../collections/sortable-collection";
import { ISorter } from "./../../interfaces/sorter";
import { GenericRelationView } from "./../partials/generic-relation";
import { CitedCaseRelationView } from "./../partials/cited-case-relation";
import {backboneViewProperties} from "../../../decorators/backbone-properties";

const template = require<string>("./citations-and-sources-controls.html");
@backboneViewProperties({
    tagName: "div",
    template
})

export class CitationsAndSourcesControlsView extends Marionette.ItemView<any> {

    public constructor(private seeAllCallback: (e: JQueryEventObject) => void, private  sortByCallback: (e: JQueryEventObject) => void, options?) {
        super(options);

    }
    public events(): Backbone.EventsHash {
        const events: Backbone.EventsHash = {};
        events[`click .btn-toggle-sources`] = (e) => this.seeAllCallback(e);
        events[`click .js-link-sort`] = (e) => this.sortByCallback(e);

        return events;
    }

}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/desktop/views/tabs/citations-and-sources-controls.ts